import { render, staticRenderFns } from "./AddOrderList.vue?vue&type=template&id=0bdfa1bf&scoped=true"
import script from "./AddOrderList.vue?vue&type=script&lang=js"
export * from "./AddOrderList.vue?vue&type=script&lang=js"
import style0 from "./AddOrderList.vue?vue&type=style&index=0&id=0bdfa1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdfa1bf",
  null
  
)

export default component.exports